class FaqLoadMore extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = async (event) => {
    const button = event.target.closest('.js-load-more');
    if (!button || !this.contains(button)) return;

    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    const rawHref = button.getAttribute('href');
    if (!rawHref) return;

    // Resolve against the current page and force the request onto the same
    // origin. blog.url can emit a .myshopify.com URL; fetching that triggers a
    // 301 to the store's primary domain, and fetch can't follow a cross-origin
    // redirect (no CORS headers) — it fails with "Failed to fetch".
    const url = new URL(rawHref, window.location.href);
    url.protocol = window.location.protocol;
    url.host = window.location.host;

    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url.toString(), { redirect: 'follow' });
      if (!response.ok) throw new Error(`Request failed: ${response.status}`);

      const markup = await response.text();
      const doc = new DOMParser().parseFromString(markup, 'text/html');

      const list = this.querySelector('.response-wrapper');
      const newItems = doc.querySelector('.response-wrapper');
      if (list && newItems) {
        list.append(...newItems.children);
      }

      const pagination = this.querySelector('.faq-topics__pagination');
      const newPagination = doc.querySelector('.faq-topics__pagination');
      if (pagination) {
        if (newPagination) {
          pagination.replaceWith(newPagination);
        } else {
          pagination.remove();
        }
      }
    } catch (error) {
      button.removeAttribute('aria-busy');
      console.error('[faq-load-more]', error);
    }
  };
}

if (!customElements.get('faq-load-more')) {
  customElements.define('faq-load-more', FaqLoadMore);
}
